import { makeImage } from '../utils/makeImage'

export interface DocHeaderType {
  urlImage: string
  titulo: string
  isAnulada: boolean
  tituloAnulada: string
  fechaIniText: string
  fechaIniValue: string
  fechaFinText: string
  fechaFinValue: string
}

export const DocHeader: React.FC<{ header: DocHeaderType }> = ({ header }) => {
  return (
    <div className="flex flex-row items-start justify-between w-full mb-4 print:mb-4 pb-2 print:pb-2">
      {/* Left: Organization Logo (col-sm-3) */}
      <div className="w-1/4">
        <img src={makeImage(header.urlImage)} alt="Logo" className="h-24 print:h-16 object-contain" />
      </div>

      {/* Center: Title and Watermark (col-sm-5) */}
      <div className="w-2/4 text-center">
        <h4 className="text-3xl print:text-xl font-bold uppercase tracking-tighter text-gray-900 leading-tight">
          {header.titulo}
        </h4>
        {header.isAnulada && (
          <div className="text-2xl print:text-lg font-bold text-red-600 uppercase mt-2 print:mt-1 leading-none">
            {header.tituloAnulada}
          </div>
        )}
      </div>

      {/* Right: Dates Table (col-sm-4) */}
      <div className="w-1/4">
        <table className="w-full text-lg print:text-[10pt] leading-tight border-separate border-spacing-x-1">
          <tbody>
            <tr>
              <td className="text-gray-600 text-left uppercase">Fecha</td>
              <th className="text-right font-bold whitespace-nowrap">{header.fechaIniValue}</th>
            </tr>
            {header.fechaFinText && (
              <tr>
                <td className="text-gray-600 text-left uppercase">{header.fechaFinText}</td>
                <th className="text-right font-bold whitespace-nowrap">{header.fechaFinValue}</th>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
